module.exports = __webpack_public_path__ + "static/media/icon-reports.39ffecb3.svg";